import { resetRequestState } from "../../utils/resetRequestState";
import { State } from "./types";

function handleEditTask(state: State): State {
  return state.map((result) => ({
    ...result,
    request: resetRequestState(),
  }));
}

export { handleEditTask };
